export default __webpack_public_path__ + "audio-distinguish55dd9e.png";